import * as React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
// Không cần import 'type' cho ThemeOptions trong JavaScript

import { inputsCustomizations } from "./customizations/inputs";
import { dataDisplayCustomizations } from "./customizations/dataDisplay";
import { feedbackCustomizations } from "./customizations/feedback";
import { navigationCustomizations } from "./customizations/navigation";
import { surfacesCustomizations } from "./customizations/surfaces";
import { colorSchemes, typography, shadows, shape } from "./themePrimitives";

// Trong JavaScript, chúng ta không định nghĩa interface cho props.
// Các props sẽ được truy cập trực tiếp từ đối tượng 'props'.

export default function AppTheme(props) {
  // Destructuring props như bình thường
  const { children, disableCustomTheme, themeComponents } = props;

  const theme = React.useMemo(() => {
    return disableCustomTheme
      ? {} // Nếu disableCustomTheme là true, trả về một đối tượng rỗng
      : createTheme({
          // Để biết thêm chi tiết về cấu hình biến CSS, xem https://mui.com/material-ui/customization/css-theme-variables/configuration/
          cssVariables: {
            colorSchemeSelector: "data-mui-color-scheme",
            cssVarPrefix: "template",
          },
          // Mới được thêm vào trong v6 để xây dựng ứng dụng chế độ sáng & tối, xem https://mui.com/material-ui/customization/palette/#color-schemes
          colorSchemes,
          typography,
          shadows,
          shape,
          components: {
            ...inputsCustomizations,
            ...dataDisplayCustomizations,
            ...feedbackCustomizations,
            ...navigationCustomizations,
            ...surfacesCustomizations,
            // themeComponents sẽ được trải ra ở đây nếu nó được cung cấp
            ...themeComponents,
          },
        });
  }, [disableCustomTheme, themeComponents]); // Dependencies của useMemo vẫn giữ nguyên

  // Logic render vẫn giống nhau
  if (disableCustomTheme) {
    return <React.Fragment>{children}</React.Fragment>;
  }

  return (
    <ThemeProvider theme={theme} disableTransitionOnChange>
      {children}
    </ThemeProvider>
  );
}
